import ScrollReveal from "scrollreveal";

ScrollReveal().reveal(".reveal", {
  delay: 200,
  distance: "2rem",
  easing: "ease-in-out",
  duration: 600,
  interval: 100
});
